import { Button, Grid, IconButton } from "@mui/material"
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import IconComponent from "./IconComponent"

export const IconsLibrary = ({ open, close, color = "#000000",returnIconSelected }) => {
	return (
		<FlexibleWidthDialog
			open={open}
			title="Iconos"
			actions={<Button onClick={close}>Cerrar</Button>}
		>
			<Grid container spacing={2}>
				{[...Array(79).keys()].map((icon, index) => (
					<Grid item xs={1} key={index}>
            <IconButton onClick={() => returnIconSelected(index+1)}>
              <IconComponent name={`icon${index+1}`} color={color} size={30}/>
            </IconButton>
					</Grid>
				))}
			</Grid>
		</FlexibleWidthDialog>
	)
}